import { atom } from 'recoil';
import { IBillingInfoState } from './types';

const initialState: IBillingInfoState | null = null;

export const BillingInfoState = atom<IBillingInfoState | null>({
  key: 'billing-info',
  default: initialState,
});
